// extracted by mini-css-extract-plugin
export var arrow = "CarouselWithImages-module__arrow--1sOyn";
export var arrowsContainer = "CarouselWithImages-module__arrowsContainer--nWOBb";
export var customSwiperSlide = "CarouselWithImages-module__customSwiperSlide--2HAIH";
export var iconTextContainer = "CarouselWithImages-module__iconTextContainer--3hUV7";
export var imageTitle = "CarouselWithImages-module__imageTitle--1ZHGK";
export var subTitleContainer = "CarouselWithImages-module__subTitleContainer--WGdzw";
export var titleContainer = "CarouselWithImages-module__titleContainer--1tsHw";